export const COLUMNS = ['md', 'tvd', 'incl', 'azi', 'dispNs', 'dispEw', 'vertSect', 'dls']
export const HEADERS = {
    md: 'MD',
    tvd: 'TVD',
    incl: 'Incl',
    azi: 'Azi',
    dispNs: 'Northing',
    dispEw: 'Easting',
    vertSect: 'Vertical Section',
    dls: 'DLS'
}
